import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ApplicationFilters = ({ filters, onFilterChange, onResetFilters, totalApplications }) => {
  const skillMatchOptions = [
    { value: 'all', label: 'Alle Matches' },
    { value: 'high', label: '80%+ Match' },
    { value: 'medium', label: '60-79% Match' },
    { value: 'low', label: 'Onder 60%' }
  ];

  const availabilityOptions = [
    { value: 'all', label: 'Alle Beschikbaarheid' },
    { value: 'immediate', label: 'Direct Beschikbaar' },
    { value: 'week', label: 'Binnen 1 Week' },
    { value: 'month', label: 'Binnen 1 Maand' }
  ];

  const sortOptions = [
    { value: 'date_desc', label: 'Nieuwste Eerst' },
    { value: 'date_asc', label: 'Oudste Eerst' },
    { value: 'rating_desc', label: 'Hoogste Rating' },
    { value: 'match_desc', label: 'Beste Match' },
    { value: 'rate_asc', label: 'Laagste Tarief' },
    { value: 'rate_desc', label: 'Hoogste Tarief' }
  ];

  const affiliateOptions = [
    { value: 'all', label: 'Alle Affiliates' },
    { value: 'techpartners', label: 'TechPartners BV' },
    { value: 'installpro', label: 'InstallPro Network' },
    { value: 'direct', label: 'Direct Aangemeld' }
  ];

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6 mb-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-semibold text-base md:text-lg text-foreground">
            Filters
          </h3>
          <span className="px-2 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
            {totalApplications} aanmeldingen
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          onClick={onResetFilters}
        >
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label="Skill Match"
          options={skillMatchOptions}
          value={filters?.skillMatch}
          onChange={(value) => onFilterChange('skillMatch', value)}
        />

        <Select
          label="Beschikbaarheid"
          options={availabilityOptions}
          value={filters?.availability}
          onChange={(value) => onFilterChange('availability', value)}
        />

        <Select
          label="Sorteer Op"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
        />

        <div className="grid grid-cols-2 gap-2">
          <Input
            type="number"
            label="Min. Tarief (€)"
            placeholder="0"
            value={filters?.minRate}
            onChange={(e) => onFilterChange('minRate', e?.target?.value)}
          />
          <Input
            type="number"
            label="Max. Tarief (€)"
            placeholder="100"
            value={filters?.maxRate}
            onChange={(e) => onFilterChange('maxRate', e?.target?.value)}
          />
        </div>

        <Select
          label="Affiliate Bron"
          options={affiliateOptions}
          value={filters?.affiliate}
          onChange={(value) => onFilterChange('affiliate', value)}
        />

        <Input
          type="search"
          label="Zoek Installateur"
          placeholder="Naam of vaardigheid..."
          value={filters?.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default ApplicationFilters;